<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card>
        <v-container>
          <v-card-title class="headline">{{ message }}</v-card-title>
          <v-progress-linear indeterminate style="progressBar" />
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'progress-dialog',
  props: {
    open: Boolean,
    message: String,
  },
  data() {
    return {
      dialog: this.open,
      messageData: this.message,
    }
  },
  watch: {
    open(newValue) {
      this.dialog = newValue
    },
    message(newValue) {
      this.messageData = newValue
    },
  },
}
</script>

<style scoped>
.progressBar {
  width: 80% !important;
}
</style>
